import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class DevModeInterceptor implements HttpInterceptor {
  constructor(private snackBar: MatSnackBar) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 429) {
          this.showDevelopmentModeWarning();
        } else if (error.error?.message === 'DEVELOPMENT_MODE_QUOTA_EXCEEDED') {
          this.showQuotaExceededWarning();
        }
        return throwError(error);
      })
    );
  }

  private showDevelopmentModeWarning(): void {
    this.snackBar.open(
      'Rate limit exceeded. Development mode has API limitations.',
      'OK',
      {
        duration: 5000,
        panelClass: ['warning-snackbar']
      }
    );
  }

  private showQuotaExceededWarning(): void {
    this.snackBar.open(
      'Development mode quota exceeded. Please try again later.',
      'OK',
      {
        duration: 8000,
        panelClass: ['error-snackbar']
      }
    );
  }
}